import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {observer} from "mobx-react"
import BienStore from "../BienStore"
import axios from "axios"

@observer
class Pieces extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // typesdebiens: [],
      loaded: false
    };
  }
  componentDidMount(){
  }
  showNextBTN(){
    let index =0

    if(BienStore.current_piece_index>=0){
      index = BienStore.current_piece_index
    }
    // id = BienStore.typesdepieces[id].id
    return <p><Link className="btn btn-large wave" to={"/piece/"+index}>Suivant</Link></p>
  }
  render () {
      return (
        <React.Fragment>
        <h2 className="center">Les pièces</h2>
        <div className="container">
          <p>Maintenant que vosu avez entré quasimment toutes les informations , il ne vous reste plus qu'à ....</p>
          <p>Tout mensonge sera facturé de 500€</p>
        </div>
        <div className="row">
          <div className="col s4 offset-s8">
          {this.showNextBTN()}
          </div>
        </div>
        </React.Fragment>
      );
    }
}

export default Pieces
